import React from "react";

function TotalLecture({ titleText, totalLectureCount }) {
    return (
        <div className="clear">
            <div className="lectureTxt2 fl">{titleText}</div>
            <div className="lectureTxt2 fr">{totalLectureCount}강</div>
        </div>
    );
}

export default TotalLecture;
